<template>
    <div class="card">
        <div class="card-header h5">Event Fees</div>
        <div class="card-body">
            <div class="col-12 col-md-12" v-if="fees.Public >= 0" >
                <table class="table table-bordered">
                    <tr v-if="fees.Public !== null" :class="fees.Member !== null && member ? 'opacity-25' : ''">
                        <th scope="row">Event Fee</th>
                        <td v-html="money(fees.Public)"></td>
                    </tr>
                    <tr v-if="fees.Member !== null && member">
                        <th scope="row">Member Fee</th>
                        <td v-html="money(fees.Member)"></td>
                    </tr>
                    <tr v-if="fees.Grad !== null">
                        <th scope="row">Graduate Credit Fee</th>
                        <td v-html="money(fees.Grad)"></td>
                    </tr>
                    <tr v-if="fees.GradFeeIncluded">
                        <th scope="row">Graduate Fee Included</th>
                        <td><i class="far fa-check-circle text-success"></i></td>
                    </tr>

                </table>
            </div>

            <div v-else class="">
                <i class="fas fa-exclamation-circle me-2 text-primary"></i>Special payment instructions. See event details from more information.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fees: {
            type: Object,
            required: true,
            default: function(data={}) {
                return data;
            },
        },

        member: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        money: function(fee, include_sign = true) {
            if (fee === 0) {
                return '<span class="text-success h6">Free</span>';
            } else if (fee === null) {
                return null;
            } else if (fee < 0) {
                return '*';
            } else if (parseFloat(fee) == 0.0) {
                return 'Free';
            } else {
                if (include_sign) {
                    return `<div class="text-success" style="font-family:ariel,sans-serif;"><i class="fas fa-dollar-sign pe-1" style="vertical-align: text-top;font-size: smaller;"></i>${ (fee / 100).toFixed(2)}</div>`;
                } else {
                    return `${parseFloat(fee).toFixed(2)}`;
                }
            }
        },

    },
}
</script>

<style scoped>
th {
    font-weight: 500 !important;
}
</style>